export default {
  handle ({commit, resolve, reject, mutation}, data) {
    if (data) {
      commit(mutation, data)
      resolve()
    } else {
      reject('Entities could not be retrieved')
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/systemoptions/store/helpers.js